import { Button } from "antd";
import { CSVLink } from "react-csv";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

const UserDataExport = ({ userData, filteredData }) => {


  // Transform data for CSV export
  const transformData = (data) => {
    return data.map((item) => ({
      EmployeeCode: item.EmployeeCode,
      EmployeeName: `${item.TitleTypeName || ""} ${item.FirstName || ""} ${item.LastName || ""
        }`.trim().toUpperCase(),
      GenderTypeName: item.GenderTypeName || "N/A",
      UserTypeName: item.UserTypeName || "N/A",
      BloodGroupTypeName: item.BloodGroupTypeName || "N/A",
      BirthDay: item.birthDay || "N/A",
      BirthAnniversary: item.BirthAnniversory || "N/A",
      MaritalStatus:
        item.MaritalStatus === true
          ? "Married"
          : item.MaritalStatus === false
            ? "Unmarried"
            : "N/A",
      MarriageAnniversary: item.MarriageAnniversary || "N/A",
      PanNumber: item.PanNumber || "N/A",
      AadharNumber: item.AadharNumber || "N/A",
      EmailId: item.EmailId || "N/A",
      PhoneNumber: item.PhoneNumber || "N/A",
      AlternateNumber: item.AlternateNumber || "N/A",
      OfficialMailId: item.OfficialMailId || "N/A",
      EmploymentTypeName: item.EmploymentTypeName || "N/A",
      ReportingToName: item.ReportingToName || "N/A",
      GradeTypeName: item.GradeTypeName || "N/A",
      DepartmentName: item.DepartmentName || "N/A",
      DesignationName: item.DesignationName || "N/A",
      ShiftName: item.ShiftName || "N/A",
      FormattedStartTime: item.FormattedStartTime || "N/A",
      FormattedEndTime: item.FormattedEndTime || "N/A",
      FormattedWorkingHours: item.FormattedWorkingHours || "N/A",
      LeavePolicyGroupName: item.LeavePolicyGroupName || "N/A",
      WeeklyWorkingDaysName: item.WeeklyWorkingDaysName || "N/A",
      StartDayName: item.StartDayName || "N/A",
      EndDayName: item.EndDayName || "N/A",
      JoinDate: item.JoinDate || "N/A",
      ProbationCompleteDate: item.ProbationComplateDate || "N/A",
      ExitDate: item.ExitDate || "N/A",
      IsPfDeducted:
        item.IsPfDeducted === true
          ? "Yes"
          : item.IsPfDeducted === false
            ? "No"
            : "N/A",
      UanNumber: item.UanNumber || "N/A",
      IsEsicDeducted:
        item.IsEsicDeducted === true
          ? "Yes"
          : item.IsEsicDeducted === false
            ? "No"
            : "N/A",
      EsicNumber: item.EsicNumber || "N/A",
      RoleName: item.RoleName || "N/A",
      CompanyOfficeName: item.CompanyOfficeName || "N/A",
      CompanyName: item.CompanyName || "N/A",
      ContactPersonRelationName: item.ContactPersonRelationName || "N/A",
      ContactPersonName: item.ContactPersonName || "N/A",
      ContactPersonNumber: item.ContactPersonNumber || "N/A",
      ContactPersonAlternateNumber: item.ContactPersonAlternateNumber || "N/A",
      ContactPersonEmailId: item.ContactPersonEmailId || "N/A",
      PermanentStreetAddress: item.PermanentStreetAddress || "N/A",
      PermanentCityName: item.PermanentCityName || "N/A",
      PermanentStateName: item.PermanentStateName || "N/A",
      PermanentCountryName: item.PermanentCountryName || "N/A",
      PermanentZipCode: item.PermanentZipCode || "N/A",
      CurrentStreetAddress: item.CurrentStreetAddress || "N/A",
      CurrentCityName: item.CurrentCityName || "N/A",
      CurrentStateName: item.CurrentStateName || "N/A",
      CurrentCountryName: item.CurrentCountryName || "N/A",
      CurrentZipCode: item.CurrentZipCode || "N/A",
    }));
  };

  // Use filteredData if provided, otherwise use userData
  const dataToExport = filteredData ? transformData(filteredData) : transformData(userData);

  // CSV headers
  const headers = [
    { label: "Employee Code", key: "EmployeeCode" },
    { label: "Employee Name", key: "EmployeeName" },
    { label: "Gender", key: "GenderTypeName" },
    { label: "User Type", key: "UserTypeName" },
    { label: "Phone Number", key: "PhoneNumber" },
    { label: "Alternate Number", key: "AlternateNumber" },
    { label: "Official Email ID", key: "OfficialMailId" },
    { label: "Personal Email ID", key: "EmailId" },
    { label: "Employment Type", key: "EmploymentTypeName" },
    { label: "PAN Number", key: "PanNumber" },
    { label: "Aadhar Number", key: "AadharNumber" },
    { label: "Blood Group", key: "BloodGroupTypeName" },
    { label: "Birth Day", key: "BirthDay" },
    { label: "Birth Anniversary", key: "BirthAnniversary" },
    { label: "Marital Status", key: "MaritalStatus" },
    { label: "Marriage Anniversary", key: "MarriageAnniversary" },
    { label: "Reporting To", key: "ReportingToName" },
    { label: "Grade Type", key: "GradeTypeName" },
    { label: "Department", key: "DepartmentName" },
    { label: "Designation", key: "DesignationName" },
    { label: "Shift", key: "ShiftName" },
    { label: "Start Time", key: "FormattedStartTime" },
    { label: "End Time", key: "FormattedEndTime" },
    { label: "Working Hours", key: "FormattedWorkingHours" },
    { label: "Leave Policy Group", key: "LeavePolicyGroupName" },
    { label: "Weekly Working Days", key: "WeeklyWorkingDaysName" },
    { label: "Start Day", key: "StartDayName" },
    { label: "End Day", key: "EndDayName" },
    { label: "Join Date", key: "JoinDate" },
    { label: "Probation Complete Date", key: "ProbationCompleteDate" },
    { label: "Exit Date", key: "ExitDate" },
    { label: "PF Deducted", key: "IsPfDeducted" },
    { label: "UAN Number", key: "UanNumber" },
    { label: "ESIC Deducted", key: "IsEsicDeducted" },
    { label: "ESIC Number", key: "EsicNumber" },
    { label: "Role", key: "RoleName" },
    { label: "Company Office", key: "CompanyOfficeName" },
    { label: "Company Name", key: "CompanyName" },
    { label: "Contact Person Relation", key: "ContactPersonRelationName" },
    { label: "Contact Person Name", key: "ContactPersonName" },
    { label: "Contact Person Number", key: "ContactPersonNumber" },
    { label: "Contact Person Alternate Number", key: "ContactPersonAlternateNumber" },
    { label: "Contact Person Email ID", key: "ContactPersonEmailId" },
    { label: "Permanent Street Address", key: "PermanentStreetAddress" },
    { label: "Permanent City", key: "PermanentCityName" },
    { label: "Permanent State", key: "PermanentStateName" },
    { label: "Permanent Country", key: "PermanentCountryName" },
    { label: "Permanent Zip Code", key: "PermanentZipCode" },
    { label: "Current Street Address", key: "CurrentStreetAddress" },
    { label: "Current City", key: "CurrentCityName" },
    { label: "Current State", key: "CurrentStateName" },
    { label: "Current Country", key: "CurrentCountryName" },
    { label: "Current Zip Code", key: "CurrentZipCode" },
  ];

  return (
    <CsvLinkBtn type="primary" className="flex items-center">
      <CSVLink
        data={dataToExport}
        headers={headers}
        filename={"employee_data.csv"}
        className="text-white"
      >
        Download CSV
      </CSVLink>
    </CsvLinkBtn>
  );
};

export default UserDataExport;
